let checkDataFileExcel = (students, routeName) => {
  let isError = false
  let indexError = []
  for (let i = 0; i < students.length; i++) {
    students[i].index = i + 1
    if (students[i].price === undefined) {
      indexError.push(i + 1)
      isError = true
    } else if (students[i].code === undefined) {
      indexError.push(i + 1)
      students[i].code = 'Thiếu thông tin'
      isError = true
    } else if (!students[i].type) {
      indexError.push(i + 1)
      students[i].price = 'Lỗi dữ liệu'
      isError = true
    } else if (!['deduction-head-fees', 'refund-fees'].includes(routeName) && students[i].type.includes('%')) {
      indexError.push(i + 1)
      students[i].price = 'Lỗi dữ liệu'
      isError = true
    } else if (students[i].type.includes('%') && (students[i].price > 100) | (students[i].price < 0)) {
      indexError.push(i + 1)
      students[i].price = 'Lỗi dữ liệu'
      isError = true
    }
  }
  return { indexError, students, isError }
}

export default {
  checkDataFileExcel
}
